import { TextField } from "@mui/material";

interface QualificationInputProps {
  disabled?: boolean;
  required?: boolean;
  qualification: string;
  showValidation?: boolean;
  onBlur?: () => void;
  setQualification: (qualification: string) => void;
}

const QualificationInput = ({
  disabled,
  required,
  qualification,
  setQualification,
  showValidation = true,
  onBlur,
}: QualificationInputProps) => {
  const isInvalid = qualification.length === 0;
  const showError = showValidation && isInvalid;

  return (
    <TextField
      sx={{
        "& .MuiInputBase-root": {
          color: showError
            ? (theme) => theme.palette.error.main
            : isInvalid
              ? undefined
              : (theme) => theme.palette.success.main,
        },
      }}
      disabled={disabled}
      focused={qualification.length > 0}
      color="success"
      required={required}
      fullWidth
      type="text"
      id="QualificationInput"
      label="Qualifizierung"
      variant="outlined"
      value={qualification}
      onChange={(event) => setQualification(event.target.value)}
      onBlur={onBlur}
      error={showError}
      helperText={showError ? "Bitte gib deine Qualifizierung ein" : ""}
    />
  );
};

export default QualificationInput;
